import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  GetBatchSignedURLsInput,
  GetBatchSignedURLsResponse,
  GetBatchSignedURLsVariables,
} from '../types';

const getClaimEvidenceFilesQuery = gql`
  query PayrollGetBatchSignedURLs($input: GetBatchSignedURLsInput!) {
    payrollGetBatchSignedURLs(input: $input) {
      code
      success
      message
      data {
        signed_url
        file_id
        name
        extension
        created_at
        size
      }
    }
  }
`;

export const getClaimEvidenceFiles = (input: GetBatchSignedURLsInput) => {
  return graphQLApi<GetBatchSignedURLsResponse, GetBatchSignedURLsVariables>({
    query: getClaimEvidenceFilesQuery,
    queryVariables: { input },
  });
};
